import * as currencyLibrary from 'currency-library';

export const typevalue = {
    name: "isCurrency",
    value: "Resource",
    options: [
        { value: true, label: 'Monetary' },
        { value: false, label: 'Non-Monetary' },
    ]
};

export const consumptionRules = {
    name: "consumptionRule",
    value: "Resource",
    options: [
        { label: "Earliest Start Time", value: "EST" },
        { label: "Latest Start Time", value: "LST" },
        { label: "Earliest Expiration Time", value: "EET" },
        { label: "Latest Expiration Time", value: "LET" },
        { label: "Earliest Start Time and Latest Expiration Time", value: "ESTLET" },
        { label: "Earliest Start Time and Earliest Expiration Time", value: "ESTEET" },
        { label: "Latest Start Time and Earliest Expiration Time", value: "LSTEET" },
        { label: "Latest Start Time and Latest Expiration Time", value: "LSTLET" },
        { label: "Earliest Expiration Time and Earliest Start Time", value: "EETEST" },
        { label: "Earliest Expiration Time and Latest Start Time", value: "EETLST" },
        { label: "Latest Expiration Time and Earliest Start Time", value: "LETEST" },
        { label: "Latest Expiration Time and Latest Start Time", value: "LETLST" }
    ]
}

export const uomOptionsData = (uomData) => {
    let uomArray = []
    uomArray = uomData.map(uom => ({
        value: uom.name,
        label: uom.name
    }));
    return uomArray
}

const allCurrencies = currencyLibrary.getAll();

const optionCurrencyCode = allCurrencies?.map((currency) => ({
    value: currency.isoCode,
    label: currency.isoCode,
}));

export const resourceOptions = [
    typevalue,
    consumptionRules,
    {
        name: "currencyCode",
        value: "Resource",
        options: optionCurrencyCode
    }
]
export { allCurrencies, optionCurrencyCode };

export const resOptionsAddition = (uomOptions, aggregate, resourceData, currencyConfig) => {
    // Initialize with base options (assuming resourceOptions is defined elsewhere)
    let options = {
        uomOptions: uomOptions || [],
        aggregateOptions: [],
        currencyOptions: []
    };

    // Handle aggregate resources
    if (aggregate && resourceData && Array.isArray(resourceData)) {
        const aggregateOptions = resourceData
            .filter((resource) => !resource.isCurrency && !resource.isAggregate)
            .map((resource) => ({
                value: resource.resourceId,
                label: resource.name
            }));
        
        options.aggregateOptions = aggregateOptions;
    }

    // Handle currency options
    if (currencyConfig && currencyConfig !== "") {
        const currencyOption = { 
            label: currencyConfig, 
            value: currencyConfig 
        };
        options.currencyOptions = [currencyOption];
    }

    return options;
};


